module.exports = __webpack_public_path__ + "img/logo-chplus-color.ad02f08c.svg";